import axios from "axios";
import FileSaver from "file-saver";
import { apiConfig } from "../configs/api";
import { loginRequest } from "../configs/auth";
import { getFileNameFromContentDispositionHeader } from "../helpers/string";
import store from "../store";
import { getAuthentication } from "./authentication/authenticationHelpers";
class ApiService {
    constructor() {
        this.isCancel = (error) => axios.isCancel(error);
        this.getAccessToken = async () => {
            var _a;
            const token = await ((_a = getAuthentication()) === null || _a === void 0 ? void 0 : _a.acquireUserToken(loginRequest));
            return token || null;
        };
        this.downloadFile = (url, config) => {
            this.ejectResponseInterceptor();
            return this.get(url, config).then(response => {
                const fileName = getFileNameFromContentDispositionHeader(response.headers["content-disposition"]);
                const fileType = response.headers["content-type"];
                FileSaver.saveAs(new Blob([response.data], { type: fileType }), fileName);
            }).finally(() => {
                this.injectResponseInterceptor();
            });
        };
        this.post = (url, data, config) => this.api.post(url, data, config);
        this.api = axios.create(apiConfig);
        this.api.interceptors.request.use(async (config) => {
            const token = await this.getAccessToken();
            config.headers.Authorization = token ? `Bearer ${token}` : "";
            return config;
        });
        this.injectResponseInterceptor();
    }
    ejectResponseInterceptor() {
        this.api.interceptors.response.eject(this.responseInterceptorIdentififer);
    }
    injectResponseInterceptor() {
        this.responseInterceptorIdentififer = this.api.interceptors.response.use((response) => {
            const data = response.data;
            if (data.userAccessDetails)
                store.auth.updateUserAccessDetails(data.userAccessDetails);
            response.data = data.data;
            return response;
        }, (error) => {
            if (!axios.isCancel(error) && error.status !== 500) {
                store.auth.updateUserAccessDetails(error.response.data.userAccessDetails);
                error.response.data = error.response.data.data;
            }
            return Promise.reject(error);
        });
    }
    get(url, config) {
        return this.api.get(url, config);
    }
    put(url, data, config) {
        return this.api.put(url, data, config);
    }
    delete(url, config) {
        return this.api.delete(url, config);
    }
}
export default new ApiService();
